var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0086 5.41797C8.37984 5.41797 5.42578 8.36935 5.42578 11.9981C5.42578 15.6296 8.37984 18.5809 12.0086 18.5809C15.6374 18.5809 18.5915 15.6296 18.5915 11.9981C18.5915 8.36928 15.6374 5.41797 12.0086 5.41797ZM12.0086 16.3867C11.5533 16.3867 11.1858 16.0191 11.1858 15.5638C11.1858 15.1113 11.5533 14.7409 12.0086 14.7409C12.4612 14.7409 12.8315 15.1113 12.8315 15.5638C12.8315 16.0191 12.4612 16.3867 12.0086 16.3867ZM12.5572 13.9455C12.5435 14.0855 12.4256 14.1924 12.2829 14.1924H11.7344C11.5917 14.1924 11.4737 14.0854 11.4601 13.9455L10.9115 8.18555C10.9115 7.55476 11.4025 7.06094 12.0086 7.06094C12.6148 7.06094 13.1058 7.55459 13.1058 8.15808L12.5572 13.9455Z",
    fill: "#E5A037"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.10dd38081c5f45af79d1446bdebb0e14.svg";
export { ForwardRef as ReactComponent };